import React from 'react';
import styled from '@benzinga/themetron';
import { BzImage } from '@benzinga/image';

export interface GoogleNewsButtonProps {
  className?: string;
  urlKey?: string;
}

const image = '/next-assets/images/google-news.png';

const urls = {
  benzinga:
    'https://news.google.com/publications/CAAqJggKIiBDQklTRWdnTWFnNEtER0psYm5wcGJtZGhMbU52YlNnQVAB?hl=en-US&gl=US&ceid=US%3Aen',
  benzingaIndia: 'https://news.google.com/publications/CAAqBwgKMLf8ygsw55fiAw?hl=en-US&gl=US&ceid=US%3Aen',
};

export const GoogleNewsButton: React.FC<GoogleNewsButtonProps> = ({ className = '', urlKey = 'benzinga' }) => {
  return (
    <Container
      aria-label="Read on Google News"
      className={`google-news-button ${className}`}
      href={urls[urlKey]}
      target="_blank"
    >
      <BzImage
        alt=""
        fetchPriority="high"
        height={45}
        layout="intrinsic"
        loading="eager"
        preload={true}
        src={image}
        width={144}
      />
    </Container>
  );
};

const Container = styled.a`
  &.google-news-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    max-height: 40px;
    min-height: 40px;
    width: 144px;

    > img {
      border-radius: ${({ theme }) => theme.borderRadius.default};
      position: relative;
    }
  }
`;

export default GoogleNewsButton;
